var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classBox},[_c('div',{staticClass:"title",on:{"click":function($event){return _vm.goTo()}}},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"items"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }